var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div class=\"mw-modal\">\n<img src=\"" + require("../../assets/alert-message.svg") + "\" alt=\"\"/>\n<h2>\nYou cannot upload CSVs right now</h2>\n<p>\nYou have chosen to identify your teachers and students using OUs and you can only use 1 method at the moment. You need to delete all your OUs before you can upload any CSVs.\n</p>\n<div class=\"mw-modal-op\">\n<a class=\"mw-btn\" ng-click=\"$close()\">Close</a>\n</div>\n</div>\n";
var id1="app/self-prov/modal-csv-not-allowed.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;